import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/select/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/select/demos/grouped/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/select/demos/multiple/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/select/demos/multiple/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/select/demos/object-values/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/select/demos/object-values/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["ViewSourceLink"] */ "/opt/build/repo/docs/src/components/Subtitle/ViewSourceLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager", webpackExports: ["DemoRootProvider"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.29_@types+react@19.3.0_next@16.4.3_@babel+core@8_799666d03052cb41c5a5be907861630d/node_modules/@mui/internal-docs-infra/abstractCreateDemo/DemoRootContext.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.29_@types+react@19.3.0_next@16.4.3_@babel+core@8_799666d03052cb41c5a5be907861630d/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.29_@types+react@19.3.0_next@16.4.3_@babel+core@8_799666d03052cb41c5a5be907861630d/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useCodeFallback"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.29_@types+react@19.3.0_next@16.4.3_@babel+core@8_799666d03052cb41c5a5be907861630d/node_modules/@mui/internal-docs-infra/CodeHighlighter/useCodeFallback.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CoordinatedLazyClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.13.1-canary.29_@types+react@19.3.0_next@16.4.3_@babel+core@8_799666d03052cb41c5a5be907861630d/node_modules/@mui/internal-docs-infra/CoordinatedLazy/CoordinatedLazyClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.4.3_@babel+core@8.0.7_@playwright+test@1.64.1_@types+node@22.20.5_babel-plugin-_ca09ed074dc6dfab9ae784b2cf603421/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SelectArrow"] */ "/opt/build/repo/packages/react/src/select/arrow/SelectArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectBackdrop"] */ "/opt/build/repo/packages/react/src/select/backdrop/SelectBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectGroupLabel"] */ "/opt/build/repo/packages/react/src/select/group-label/SelectGroupLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectGroup"] */ "/opt/build/repo/packages/react/src/select/group/SelectGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectIcon"] */ "/opt/build/repo/packages/react/src/select/icon/SelectIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectItemIndicator"] */ "/opt/build/repo/packages/react/src/select/item-indicator/SelectItemIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectItemText"] */ "/opt/build/repo/packages/react/src/select/item-text/SelectItemText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectItem"] */ "/opt/build/repo/packages/react/src/select/item/SelectItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectLabel"] */ "/opt/build/repo/packages/react/src/select/label/SelectLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectList"] */ "/opt/build/repo/packages/react/src/select/list/SelectList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectPopup"] */ "/opt/build/repo/packages/react/src/select/popup/SelectPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectPortal"] */ "/opt/build/repo/packages/react/src/select/portal/SelectPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectPositioner"] */ "/opt/build/repo/packages/react/src/select/positioner/SelectPositioner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectRoot"] */ "/opt/build/repo/packages/react/src/select/root/SelectRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectScrollDownArrow"] */ "/opt/build/repo/packages/react/src/select/scroll-down-arrow/SelectScrollDownArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectScrollUpArrow"] */ "/opt/build/repo/packages/react/src/select/scroll-up-arrow/SelectScrollUpArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectSeparator"] */ "/opt/build/repo/packages/react/src/select/separator/SelectSeparator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectTrigger"] */ "/opt/build/repo/packages/react/src/select/trigger/SelectTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectValue"] */ "/opt/build/repo/packages/react/src/select/value/SelectValue.tsx");
